import { LIFE_API_BASE_URL_V5, STUDIO_API_BASE_URL_V5, WORKSPACE_API_BASE_URL_V7 } from '../config';

export const WorkspaceAPIRoutes = {
  getUsersWorkspaces: () => `${STUDIO_API_BASE_URL_V5}/shut_up_meg`,
  getWorkspaceContext: () => `${STUDIO_API_BASE_URL_V5}/workspace_context`,
  getDashLookML: () => `${STUDIO_API_BASE_URL_V5}/lookml`,
  getWorkspaceTypes: () => `${WORKSPACE_API_BASE_URL_V7}/types`,
  createWorkspace: () => `${STUDIO_API_BASE_URL_V5}/workspace`,
  saveWorkspace: () => `${STUDIO_API_BASE_URL_V5}/save_workspace`,
  renameWorkspace: () => `${STUDIO_API_BASE_URL_V5}/rename_workspace`,
  duplicateWorkspace: () => `${STUDIO_API_BASE_URL_V5}/duplicate_workspace`,
  duplicateWorkspacev7: () => `${WORKSPACE_API_BASE_URL_V7}/duplicate`,
  deleteWorkspace: () => `${STUDIO_API_BASE_URL_V5}/archive_workspace`,
  deleteWorkspaceV7: () => `${WORKSPACE_API_BASE_URL_V7}/archive`,
  getDependencies: () => `${STUDIO_API_BASE_URL_V5}/workspace_dependencies`,
  getSessionWorkspace: (platformSessionID: string) =>
    `${LIFE_API_BASE_URL_V5}/get_session?platformSessionID=${platformSessionID}`,
  expansionMetaData: () => `${STUDIO_API_BASE_URL_V5}/expansion_metadata`,
  getWorkspaceNameValidation: () => `${STUDIO_API_BASE_URL_V5}/workspace_name_check`,
  createWorkspaceDTC: () => `/v7/workspaces/create`,
  getWorkspaces: () => `/v7/workspaces/list`,
  saveWorkspaceV7: () => `/v7/workspaces/save`,
  renameWorkspaceV7: () => `${WORKSPACE_API_BASE_URL_V7}/rename`,
  getWorkspaceNameValidationV7: () => `${WORKSPACE_API_BASE_URL_V7}/name_availability`,
};
